module.exports = __webpack_public_path__ + "img/sv3.91c6abdb.svg";